import React from "react";
import ToggleButton from "../../../../components/ToggleButton/index";
import { updateShowPriceValue } from "../../../../helper";

export default function ShowPrice(props) {
  const { showPriceValue, setShowPriceValue } = props;

  return (
    <>
      <h2 className="pt-3 pl-3">Show Price</h2>

      <h2 className="text-center m-5">
        This will show the price in the product catalog in frontend
      </h2>
      <ToggleButton
        secondLabel="Yes"
        firstLabel="No"
        checkedValue={showPriceValue}
        handleOnChange={() => {
          if (
            window.confirm(
              `This will ${
                showPriceValue ? "Hide" : "Show"
              } the product prices on the frontend. Press OK to confirm`
            )
          ) {
            updateShowPriceValue(!showPriceValue).then(
              (result) => result && setShowPriceValue(!showPriceValue)
            );
          }
        }}
      />
    </>
  );
}
